import { I18NextService } from "@services/I18NextService";
import { Component } from "inferno";
import { PublicOAuthProvider } from "lemmy-js-client";
import { v4 as uuidv4 } from "uuid";

type OAuthLoginProps = { oauth_providers: PublicOAuthProvider[] };

export class OAuthLogin extends Component<OAuthLoginProps, object> {
  render() {
    return (
      (this.props.oauth_providers?.length || 0) > 0 && (
        <>
          <div className="row mt-3 mb-2"></div>
          <div className="row">
            <div className="col col-12 col-lg-6 offset-lg-3">
              <h2 className="h4 mb-3">
                {I18NextService.i18n.t("oauth_use_external_provider")}
              </h2>
              {(this.props.oauth_providers ?? []).map(
                (provider: PublicOAuthProvider) => (
                  <button
                    className="btn btn-primary my-2 d-block"
                    onClick={() => handleLoginWithProvider(provider)}
                  >
                    {provider.display_name}
                  </button>
                ),
              )}
            </div>
          </div>
        </>
      )
    );
  }
}

export function buildOAuthAuthorizeUrl(
  oauth_provider: PublicOAuthProvider,
  redirectUri: string,
  state: string,
  options?: {
    login_ticket?: string;
    answer?: string;
  },
): string {
  const params = [
    `client_id=${encodeURIComponent(oauth_provider.client_id)}`,
    `response_type=code`,
    `scope=${encodeURIComponent(oauth_provider.scopes)}`,
    `redirect_uri=${encodeURIComponent(redirectUri)}`,
    `state=${state}`,
  ];
  if (options?.login_ticket) {
    params.push(
      `login_ticket=${encodeURIComponent(options.login_ticket)}`,
    );
  }
  if (options?.answer) {
    params.push(`answer=${encodeURIComponent(options.answer)}`);
  }
  return oauth_provider.authorization_endpoint + "?" + params.join("&");
}

export function handleLoginWithProvider(
  oauth_provider: PublicOAuthProvider,
  username?: string,
  prev?: string,
  answer?: string,
  show_nsfw?: boolean,
  stay_logged_in?: boolean,
  login_ticket?: string,
) {
  const redirectUri = `${window.location.origin}/oauth/callback`;
  const state = uuidv4();
  const requestUri = buildOAuthAuthorizeUrl(
    oauth_provider,
    redirectUri,
    state,
    { login_ticket, answer },
  );

  const oauth_state: LocalOauthState = {
    state,
    oauth_provider_id: oauth_provider.id,
    redirect_uri: redirectUri,
    prev: prev ?? "/",
    username: username,
    answer: answer,
    show_nsfw: show_nsfw,
    stay_logged_in: stay_logged_in,
    expires_at: Date.now() + 5 * 60_000,
  };
  localStorage.setItem("oauth_state", JSON.stringify(oauth_state));

  window.location.assign(requestUri);
}

export interface LocalOauthState {
  state: string;
  oauth_provider_id: number;
  redirect_uri: string;
  prev: string;
  answer?: string;
  show_nsfw?: boolean;
  stay_logged_in?: boolean;
  username?: string;
  expires_at?: number;
}

export function resolveAimooOAuthProvider(
  providers: PublicOAuthProvider[],
): PublicOAuthProvider | undefined {
  const configuredId = process.env.LEMMY_UI_AIMOO_OAUTH_PROVIDER_ID;
  if (configuredId) {
    const id = Number.parseInt(configuredId, 10);
    return providers.find(p => p.id === id);
  }
  return (
    providers.find(p => p.display_name === "AIMOO") ?? providers[0]
  );
}
